export enum HomePageReactQueryKeys {
    HomeProperties = 'home-page-properties',
    Stories = 'stories',
}
